// extracted by mini-css-extract-plugin
export default {"priceSection":"styles_priceSection__ZgXl-","header":"styles_header__OFL7s","inputField":"styles_inputField__tM+go"};